Router = App.loadClass 'core::Router'

class exports.MapsUploadRouter extends Router

    prefix: 'MapsUpload'
    module_name: 'MapsUploadRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @module.filter 'typeFilter', () ->
            (collection, text) ->
                # Skip processing unless the user provides us a string
                return collection unless text isnt  ''

                # Here we search the collection for a match and return
                # the new list. Converting everything to lowercase
                # to provide case-insensitive searches
                list = []
                text = text.toLowerCase()

                for type in collection
                    if typeof type is 'object'
                        type_name = type.name.toLowerCase()
                    else
                        type_name = type.toLowerCase()

                    if type_name.indexOf(text) isnt -1
                        list.push(type)

                return list

        @module.filter 'yearFilter', () ->
            (collection, text) ->
                return collection unless text isnt ''

                list = []

                for year in collection
                    year = year.toString()

                    if year.indexOf(text) isnt -1
                        list.push(year)

                return list

        # Generic service for upload process
        @service 'grower::Angular/Data/Add/Maps/Upload/Services/MapsUploadService', [
            '$http', '$uibModal', 'MapsUpload.Services.TypeHelpService'
        ]

        # Service to match upload types to help blurbs
        @service 'grower::Angular/Data/Add/Maps/Upload/Services/TypeHelpService'

        # Service for managing data within the Confirmation Matrix
        @service 'grower::Angular/Data/Add/Maps/Upload/Conversion/Services/DataManagementService', [
            '$http', '$rootScope'
        ]

        # Service to act as an interface for the controller + tab/table services
        # as well as fetching data from the backend
        @service 'grower::Angular/Data/Add/Maps/Upload/Conversion/Services/MapsConversionMatrixService', [
            '$http'
        ]

        # Upload Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/DialogController', [
            '$scope',
            '$transitions',
            '$state',
            'MapsUpload.Services.MapsUploadService',
            '$uibModalInstance',
            '$window',
            '$transition$',
        ]

        # Duplicate File Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/DuplicateFileDialogController', [
            '$state',
            '$transitions',
            '$scope',
            '$uibModalInstance',
            'MapsUpload.Services.MapsUploadService',
            'data',
            '$window',
            '$rootScope',
        ]

        # Invalid Shapefile Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/InvalidShapefileDialogController', [
            '$state',
            '$scope', '$transitions',
            '$uibModalInstance',
            'data'
        ]

        # Conversion Status Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/StatusController', [
            '$scope',
            '$transitions',
            '$state',
            '$uibModal',
            'Data.Services.MapsConversionService',
            'Core.Services.Loading'
        ]

        # Confirmation Matrix Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationController', [
            '$scope',
            '$transitions',
            '$state',
            'MapsUpload.Services.MapsConversionMatrixService',
            '$window',
            '$timeout'
        ]

        # Confirmation Matrix Yield Tab Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationYieldController', [
            '$scope',
            '$transitions',
            '$state',
            'MapsUpload.Services.MapsConversionMatrixService',
            'MapsUpload.Services.DataManagementService',
            'Core.Services.Loading',
            '$window',
            '$uibModal',
        ]

        # Confirmation Matrix Planting Tab Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationPlantingController', [
            '$scope',
            '$transitions',
            '$state',
            'MapsUpload.Services.MapsConversionMatrixService',
            'MapsUpload.Services.DataManagementService',
            'Core.Services.Loading',
            '$window',
            '$uibModal',
        ]

        # Confirmation Matrix Managment Zone Tab Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationManagementZoneController', [
            '$scope',
            '$transitions',
            '$state',
            'MapsUpload.Services.MapsConversionMatrixService',
            'MapsUpload.Services.DataManagementService',
            'Core.Services.Loading',
            '$window',
        ]

        # Confirmation Matrix Ingredion Survey Dialog Controller
        @controller 'grower::Angular/Data/Add/Maps/Upload/Conversion/IngredionDialogController', [
            '$state',
            '$scope',
            '$transitions',
            '$uibModalInstance',
            '$http',
            'survey'
        ]

    registerRoutes: ($stateProvider) ->
        return
        # $stateProvider
            # .state 'grower.data.add.status',
            #     url: '/status'
            #     views:
            #         '$default@grower':
            #             templateUrl: 'backend/grower/maps-conversion/status'
            #             controller: 'MapsUpload.Controllers.StatusController'

            # .state 'grower.data.add.confirm',
            #     url: '/confirmation'
            #     views:
            #         '$default@grower':
            #             templateUrl: 'backend/grower/maps-conversion/confirmation'
            #             controller: 'MapsUpload.Controllers.ConfirmationController'

            # .state 'grower.data.add.confirm.yield',
            #     url: '/confirmation/yield'
            #     views:
            #         'tab-content':
            #             templateUrl: 'backend/grower/maps-conversion/yield'
            #             controller: 'MapsUpload.Controllers.ConfirmationYieldController'

            # .state 'grower.data.add.confirm.planting',
            #     url: '/confirmation/planting'
            #     views:
            #         'tab-content':
            #             templateUrl: 'backend/grower/maps-conversion/planting'
            #             controller: 'MapsUpload.Controllers.ConfirmationPlantingController'

            # .state 'grower.data.add.confirm.mmz',
            #     url: '/confirmation/mmz'
            #     views:
            #         'tab-content':
            #             templateUrl: 'backend/grower/maps-conversion/management-zone'
            #             controller: 'MapsUpload.Controllers.ConfirmationManagementZoneController'
